import './Modal.scss';
import PropTypes from 'prop-types';

// General Modal Component
const Modal = ({ title, content, setModalOpen }) => {
  return (
    <>
      <div className="modal_overlay" />
      <div className={`modal_container ${!title && 'no_title'}`}>
        {title && (
          <div className="modal_title">
            {title}
            <div
              className="modal_cancel"
              onClick={() => {
                setModalOpen(false);
              }}
            >
              Cancel
            </div>
          </div>
        )}
        {content}
      </div>
    </>
  );
};

Modal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.element,
  setModalOpen: PropTypes.func,
};

export default Modal;
